<div class="dossier-status" role="status" [attr.aria-label]="resolvedLabel()">
    <i class="dossier-status__icon" [class]="resolvedIconClasses() + ' text-' + resolvedColor()" aria-hidden="true"></i>
    <div class="dossier-status__label">{{ resolvedLabel() }}</div>
</div>
